import { render, staticRenderFns } from "./NhlBrowseTeam.vue?vue&type=template&id=a15e11e4&scoped=true"
import script from "./NhlBrowseTeam.vue?vue&type=script&lang=js"
export * from "./NhlBrowseTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15e11e4",
  null
  
)

export default component.exports